/* KinderFizz cart drawer: Special instructions + Discount code (see snippets/kf-cart-actions.liquid) */
(() => {
  if (window.KFCartActions) return;
  const KF = (window.KFCartActions = {
    noteValue: null,
    queuedNote: null,
    notePending: null,
    statusTimer: null,
    extraCodes: [],
    flash: null,
  });
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTION = 'cart-drawer';
  const same = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();

  const postJSON = async (path, body) => {
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('Cart request failed (' + res.status + ')');
    return res.json();
  };

  const sectionHTML = async (data) => {
    if (data && data.sections && data.sections[SECTION]) return data.sections[SECTION];
    try {
      const res = await fetch(root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } });
      const json = await res.json();
      return json[SECTION] || null;
    } catch (error) {
      return null;
    }
  };

  const renderDrawer = (html) => {
    const current = document.querySelector('#CartDrawer .drawer__inner');
    if (!html || !current) return false;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    if (!fresh) return false;
    const openKeys = Array.from(current.querySelectorAll('.kf-disclosure[open]')).map((el) => el.dataset.kfKey);
    current.innerHTML = fresh.innerHTML;
    openKeys.forEach((key) => {
      const el = current.querySelector('.kf-disclosure[data-kf-key="' + key + '"]');
      if (el) el.open = true;
    });
    return true;
  };

  // Keep the panel compact: opening one section closes the other.
  document.addEventListener(
    'toggle',
    (event) => {
      const el = event.target;
      if (!(el instanceof HTMLDetailsElement) || !el.open || !el.classList.contains('kf-disclosure')) return;
      const group = el.closest('.kf-cart-actions');
      if (!group) return;
      group.querySelectorAll('.kf-disclosure[open]').forEach((other) => {
        if (other !== el) other.open = false;
      });
    },
    true
  );

  class KfCartNote extends HTMLElement {
    connectedCallback() {
      if (this.kfReady) return;
      this.textarea = this.querySelector('textarea');
      if (!this.textarea) return;
      this.kfReady = true;
      if (KF.noteValue !== null && this.textarea.value !== KF.noteValue) this.textarea.value = KF.noteValue;
      if (KF.queuedNote === null) KF.queuedNote = this.textarea.value;
      this.textarea.addEventListener('input', () => {
        KF.noteValue = this.textarea.value;
        this.setStatus('');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save(), 600);
      });
      this.textarea.addEventListener('blur', () => this.flush());
    }

    disconnectedCallback() {
      this.flush();
    }

    flush() {
      if (!this.timer) return;
      clearTimeout(this.timer);
      this.save();
    }

    save() {
      this.timer = null;
      const note = KF.noteValue === null ? this.textarea.value : KF.noteValue;
      if (note === KF.queuedNote) return;
      KF.queuedNote = note;
      this.setStatus(this.dataset.msgSaving);
      const previous = KF.notePending || Promise.resolve();
      const request = previous
        .catch(() => {})
        .then(() => postJSON('cart/update.js', { note }))
        .then(() => this.setStatus(this.dataset.msgSaved, false, true))
        .catch(() => this.setStatus(this.dataset.msgError, true))
        .finally(() => {
          if (KF.notePending === request) KF.notePending = null;
        });
      KF.notePending = request;
    }

    setStatus(text, isError, autoClear) {
      const status =
        document.querySelector('#CartDrawer [data-kf-note-status]') || this.querySelector('[data-kf-note-status]');
      if (!status) return;
      clearTimeout(KF.statusTimer);
      status.textContent = text || '';
      status.classList.toggle('is-error', Boolean(isError));
      if (autoClear) {
        KF.statusTimer = setTimeout(() => {
          status.textContent = '';
        }, 2000);
      }
    }
  }

  class KfCartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.kfReady) return;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="discount"]');
      this.message = this.querySelector('[data-kf-discount-message]');
      this.list = this.querySelector('[data-kf-discount-codes]');
      this.template = this.querySelector('template[data-kf-pill-template]');
      if (!this.form || !this.input || !this.list) return;
      this.kfReady = true;
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.apply();
      });
      this.input.addEventListener('input', () => this.showMessage(''));
      this.list.addEventListener('click', (event) => {
        const button = event.target.closest('[data-kf-remove]');
        if (!button) return;
        event.preventDefault();
        const pill = button.closest('[data-discount-code]');
        if (pill) this.remove(pill.dataset.discountCode);
      });
      this.syncExtraPills();
      if (KF.flash) {
        this.showMessage(KF.flash.text, KF.flash.type);
        KF.flash = null;
      }
    }

    renderedCodes() {
      return Array.from(this.list.querySelectorAll('[data-discount-code]')).map((el) => el.dataset.discountCode);
    }

    syncExtraPills() {
      if (!this.template || !KF.extraCodes.length) return;
      const rendered = this.renderedCodes();
      KF.extraCodes.forEach((code) => {
        if (rendered.some((c) => same(c, code))) return;
        const pill = this.template.content.firstElementChild.cloneNode(true);
        pill.dataset.discountCode = code;
        pill.querySelector('.kf-discount__pill-code').textContent = code;
        pill.querySelector('[data-kf-remove]').setAttribute('aria-label', (this.dataset.labelRemove || 'Remove') + ' ' + code);
        this.list.appendChild(pill);
      });
    }

    async cartCodes() {
      try {
        const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        if (Array.isArray(cart.discount_codes)) {
          return cart.discount_codes.filter((d) => d.applicable).map((d) => d.code);
        }
      } catch (error) {}
      return this.renderedCodes();
    }

    async apply() {
      if (this.busy) return;
      const code = this.input.value.trim();
      if (!code) {
        this.showMessage(this.dataset.msgEmpty, 'error');
        this.input.focus();
        return;
      }
      this.setBusy(true);
      this.showMessage('');
      try {
        if (KF.notePending) await KF.notePending;
        const existing = await this.cartCodes();
        if (existing.some((c) => same(c, code))) {
          this.input.value = '';
          this.showMessage(this.format(this.dataset.msgDuplicate, code), 'info');
          return;
        }
        const data = await postJSON('cart/update.js', {
          discount: existing.concat(code).join(','),
          sections: [SECTION],
        });
        const result = Array.isArray(data.discount_codes)
          ? data.discount_codes.find((d) => same(d.code, code))
          : { applicable: true };
        if (!result || result.applicable === false) {
          await postJSON('cart/update.js', { discount: existing.join(',') }).catch(() => {});
          this.showMessage(this.format(this.dataset.msgInvalid, code), 'error');
          this.input.select();
          return;
        }
        const html = await sectionHTML(data);
        if (!html) {
          window.location.reload();
          return;
        }
        const shown = Array.from(
          new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-discount-code]')
        ).some((el) => same(el.dataset.discountCode, code));
        if (!shown) {
          // e.g. free-shipping codes: accepted now, but only priced at checkout
          KF.extraCodes.push(result.code || code);
          KF.flash = { text: this.format(this.dataset.msgCheckout, code), type: 'success' };
        }
        this.afterUpdate(html);
      } catch (error) {
        this.showMessage(this.dataset.msgError, 'error');
      } finally {
        this.setBusy(false);
      }
    }

    async remove(code) {
      if (this.busy || !code) return;
      this.setBusy(true);
      this.showMessage('');
      try {
        const remaining = (await this.cartCodes()).filter((c) => !same(c, code));
        KF.extraCodes = KF.extraCodes.filter((c) => !same(c, code));
        const data = await postJSON('cart/update.js', { discount: remaining.join(','), sections: [SECTION] });
        KF.flash = { text: this.format(this.dataset.msgRemoved, code), type: 'info' };
        this.afterUpdate(await sectionHTML(data));
      } catch (error) {
        this.showMessage(this.dataset.msgError, 'error');
      } finally {
        this.setBusy(false);
      }
    }

    afterUpdate(html) {
      if (!renderDrawer(html)) {
        window.location.reload();
        return;
      }
      const fresh = document.querySelector('#CartDrawer kf-cart-discount');
      const details = fresh && fresh.closest('details');
      if (!details) return;
      details.open = true;
      const summary = details.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    }

    setBusy(state) {
      this.busy = state;
      if (state) this.setAttribute('aria-busy', 'true');
      else this.removeAttribute('aria-busy');
      this.input.readOnly = state;
    }

    showMessage(text, type) {
      if (!this.message) return;
      this.message.textContent = text || '';
      this.message.hidden = !text;
      if (type) this.message.dataset.type = type;
      else delete this.message.dataset.type;
    }

    format(template, code) {
      return String(template || '').replace('[code]', String(code).toUpperCase());
    }
  }

  if (!customElements.get('kf-cart-note')) customElements.define('kf-cart-note', KfCartNote);
  if (!customElements.get('kf-cart-discount')) customElements.define('kf-cart-discount', KfCartDiscount);
})();